import { useLogger } from '#apps/client-web/app/hooks/use-logger';
import { useAuth } from '#apps/client-web/features/auth/hooks/use-auth';
import { MainPageLayout } from '#apps/client-web/app/components/main-page-layout';

import { UserProfilePageContainer } from './user-profile-page.container';
import { useUserProfilePageViewModel } from './user-profile-page.view-model';

export const UserProfilePage = () => {
  const logger = useLogger('pages/user-profile');
  const auth = useAuth({ logger });

  const viewModel = useUserProfilePageViewModel({ auth, logger });

  return (
    <MainPageLayout title="User Profile" pageContentProps={{ maxWidth: 'sm' }}>
      <UserProfilePageContainer viewModel={viewModel} />
    </MainPageLayout>
  );
};
